import { SxBaseContainerDesigner } from '../../base/base-container-designer-component';
import { DesignAttributeType } from '../../../../types/designer-attribute-type';
import { IDesignerFactoryService } from '../../../../services/designer-factory-interface';
import { DragulaService } from 'ng2-dragula';
import { Component, OnInit, OnDestroy, ViewChild, ViewContainerRef, ElementRef } from '@angular/core';

@Component({
    selector: 'sx-fileexportgroup-designer',
    templateUrl: './fileExportGroup.designer.component.html'
})

//This can be usefull later on
export class SxFileExportGroupDesigner extends SxBaseContainerDesigner implements OnInit, OnDestroy {
    @ViewChild('groupPanelContainer', { read: ViewContainerRef }) private groupPanelContainer: ViewContainerRef;

    constructor(dragulaService: DragulaService,
        designerFactoryService: IDesignerFactoryService,
        container: ElementRef) {

        super(dragulaService, designerFactoryService, 'SxFileExportGroup', container);
    }

    loadDefaults(): void {
        super.loadDefaults();
        this.controlContext.title = '';
        this.controlContext.linkedUrl=null;
    }

    getDesignerInfo(): any {
        const info = super.getDesignerInfo();

        info['title'] = this.controlContext.title;
        info['linkedUrl'] = this.controlContext.linkedUrl;
        return info;
    }

    buildAttributes(): void {
        super.buildAttributes();

        const titleAtt = new DesignAttributeType(this.controlContext, 'string', 'title','TITLE');
        const linkedUrl = new DesignAttributeType(this.controlContext, 'string', 'linkedUrl','PRELINKED_RULE');

        this.attributes.push(titleAtt);
        this.attributes.push(linkedUrl);
    }

    ngOnInit(): void {
        this.placeHolderContainer = this.groupPanelContainer;
        super.ngOnInit();
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/files-manager/fileExportGroup.designer.component.ts